export default "__VITE_ASSET__IvGbMx1b__"